import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
const imgPath = '/i3/saas_templates/shopiko/';

const BG = [
	{
		name: 'Active',
		img: imgPath + 'Active.jpg',
		href: 'https://active.shopiko.bg'
	},
	{
		name: 'Adventure',
		img: imgPath + 'Adventure.jpg',
		href: 'https://adventure.shopiko.bg'
	},
	{
		name: 'Shine',
		img: imgPath + 'Shine.jpg',
		href: 'https://shine.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const EN = [
	{
		name: 'Active',
		img: imgPath + 'Active.jpg',
		href: 'https://active.shopiko.bg'
	},
	{
		name: 'Adventure',
		img: imgPath + 'Adventure.jpg',
		href: 'https://adventure.shopiko.bg'
	},
	{
		name: 'Shine',
		img: imgPath + 'Shine.jpg',
		href: 'https://shine.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];